import React from 'react';
import { makeStyles, tokens, Text } from '@fluentui/react-components';
import { useNavigation } from '../hooks/routing';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/Button';

const useStyles = makeStyles({
  root: {
    paddingBlock: tokens.spacingVerticalXXL,
    paddingInline: tokens.spacingHorizontalXXL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXXL,
    alignItems: 'center',
    height: '100%',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  mainText: {
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase600,
    color: tokens.colorNeutralForeground1,
    textAlign: 'center',
    lineHeight: tokens.lineHeightHero700,
  },
  subText: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase300,
    textAlign: 'center',
    lineHeight: tokens.lineHeightBase400,
  },
  button: {
    alignSelf: 'stretch',
  },
  contentWrapper: {
    paddingBlock: tokens.spacingVerticalXXL,
    paddingInline: tokens.spacingHorizontalXS,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXXL,
    alignItems: 'center',
  },
});

export const WelcomeScreen = () => {
  const styles = useStyles();
  const { navigate } = useNavigation<'welcome'>();
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.contentWrapper}>
        <img
          alt={t('WELCOME.LOGO_ALT')}
          src="assets/CM-icon.png"
          width={120}
        />
        <div className={styles.textWrapper}>
          <Text className={styles.mainText}>{t('WELCOME.TITLE')}</Text>
          <Text className={styles.subText}>{t('WELCOME.SUBTITLE')}</Text>
        </div>
      </div>
      <Button
        size="large"
        className={styles.button}
        appearance="primary"
        onClick={() => navigate('login')}
      >
        {t('WELCOME.LOGIN')}
      </Button>
    </div>
  );
};
